<template>
  <div>
    <div style="width: 100vw; background-color: #f9f9f9; display: flex; flex-direction: row; justify-content: center; align-items: center;">
      <div 
        :style="'width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; padding-bottom: '+($store.getters.getScreenWidth>=650 ? '' : '40px')+'; padd max-width: 1920px; margin-top: 80px; display: flex; flex-direction: column; justify-content: center; align-items: center;'">
        <div :style="'display: flex; flex-direction: column; padding-bottom: 100px; width: 100%; text-align: center;'">
          
          <span :style="'font-size: '+getFont54+'; font-weight: 500;'">
              Easy Tailor App is<br>available on app stores.
          </span>

          <div style="margin-top: 50px; width: 100%; display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <a href="https://apps.apple.com/us/app/easytailorapp-com/id1639966758">
              <img src="https://etacdn.b-cdn.net/app-store.png" style="width: 150px;" alt="easytailorapp">
            </a>

            <a href="https://play.google.com/store/apps/details?id=com.raizzon.easytailorapp">
              <img src="https://etacdn.b-cdn.net/android-store.png" style="margin-left: 40px; width: 150px;" alt="easytailorapp">
            </a>
          
          </div>
          
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
    computed: {
      getFont54() {
        if(this.$store.getters.getScreenWidth<560 && this.$store.getters.getScreenWidth>429) {
          return '34px'
        } else if(this.$store.getters.getScreenWidth<=429 && this.$store.getters.getScreenWidth>373) {
          return '30px'
        } else if(this.$store.getters.getScreenWidth<=373) {
          return '24px'
        }
        return this.$store.getters.getFontSizes.f54
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/AppDownload/Row1.vue